module.exports = __webpack_public_path__ + "static/media/44639213_2199897783418734_7987866587547828224_o.4eddbb7c.jpg";